import axios from 'axios'
import store from '@/store'

export const baseURL = '/api'
export const authURL = '/auth-api'
export const adminURL = '/admin-api'
export const errorURL = '/error-api'
export const fiasURL = '/fias-search'
export const mockProtocol = 'https:/'

export const repository = axios.create({ baseURL })
export const repositoryAuth = axios.create({ baseURL: authURL })
export const repositoryAdmin = axios.create({ baseURL: adminURL })
export const repositoryError = axios.create({ baseURL: errorURL })
export const repositoryFiasURL = axios.create({ baseURL: fiasURL })

repository.interceptors.request.use(
  config => {
    const token = store.state.user.accessToken
    if (token) {
      // eslint-disable-next-line
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

const createErrorInterceptor = repository => {
  repository.interceptors.response.use(undefined, async error => {
    return Promise.reject(error.response)
  })
}

;[repository, repositoryAuth, repositoryAdmin, repositoryError, repositoryFiasURL].forEach(rep =>
  createErrorInterceptor(rep)
)

export const getURL = (url, options) => {
  const resultURL = new URL(`${mockProtocol}/${url}`)
  if (options.searchParams) {
    for (let key in options.searchParams) {
      resultURL.searchParams.append(key, options.searchParams[key])
    }
  }

  return resultURL.href.slice(mockProtocol.length)
}
